export const isActive = ({ score, value }: { score: number; value: number | null }) => {
  return !!(value && score <= value);
};
